import React, { useEffect } from 'react';
import './VersionOutdatedOverlay.css';

interface VersionOutdatedOverlayProps {
  isVisible: boolean;
  currentVersion?: string;
  latestVersion?: string;
}

const VersionOutdatedOverlay: React.FC<VersionOutdatedOverlayProps> = ({
  isVisible,
  currentVersion,
  latestVersion,
}) => {
  useEffect(() => {
    if (!isVisible) return;

    // Блокировать скролл body когда overlay показан
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  const handleReload = () => {
    // Очистить localStorage перед обновлением (опционально)
    // localStorage.clear();

    // Перезагрузить страницу
    window.location.reload();
  };

  return (
    <div className="version-outdated-overlay">
      <div className="version-outdated-modal">
        <div className="version-outdated-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </div>

        <h2 className="version-outdated-title">Доступна новая версия</h2>

        <p className="version-outdated-message">
          Для продолжения работы необходимо обновить страницу
        </p>

        {currentVersion && latestVersion && (
          <div className="version-outdated-info">
            <div className="version-outdated-info-item">
              <span className="version-outdated-label">Текущая версия:</span>
              <span className="version-outdated-value">{currentVersion}</span>
            </div>
            <div className="version-outdated-info-item">
              <span className="version-outdated-label">Новая версия:</span>
              <span className="version-outdated-value version-outdated-highlight">
                {latestVersion}
              </span>
            </div>
          </div>
        )}

        <button className="version-outdated-button" onClick={handleReload}>
          Обновить сейчас
        </button>

        <p className="version-outdated-note">
          Все несохраненные данные могут быть потеряны
        </p>
      </div>
    </div>
  );
};

export default VersionOutdatedOverlay;
